import {React, useEffect, useRef } from 'react';
import Parallax from 'parallax-js';

import 'swiper/swiper-bundle.min.css';

import rub from "../img/teamcoach.jpg";
import team from "../img/team-tr.jpg";
import "./images.css";


export default function Team() {
      const sceneRef = useRef(null); // Reference for the container
    
      useEffect(() => {
          if (sceneRef.current) {
            const parallaxInstance = new Parallax(sceneRef.current, {
              relativeInput: true, // Adjusts movement based on mouse or scroll
            });
    
            return () => parallaxInstance.destroy(); // Cleanup on unmount
          }
      }, []);
      
      return (
        <div>
          <section className="overflow-hidden">
            <div className="container pt-2 pt-sm-4 pb-sm-2 pb-md-4 py-xl-5 mt-5">
              <div className="row align-items-center py-3 mt-md-1 my-lg-2 my-xl-2 my-xxl-3">
                <div className="col-lg-7 order-lg-2 d-flex justify-content-center justify-content-lg-end mb-4 mb-md-5 mb-lg-0 pb-3 pb-md-0">
                  <div className="parallax me-lg-n4 me-xl-n5" style={{ maxWidth: '667px' }}>
                    <div ref={sceneRef} className="container mt-4">
                      <div className="parallax-container position-relative" data-depth="0.1"><img className="img-fluid custom-image shadow-lg" src={rub} alt="Team Coach"/></div>
                        <br/>
                      <div className="parallax-container position-relative" data-depth="0.1"><img className="img-fluid custom-image shadow-lg" src={team} alt="Team Sertificate"/></div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 order-lg-0">
                  <h2 className="display-6 text-center text-lg-start pb-sm-2 pb-md-3">Командный коучинг </h2>
                  <h2 className="lead text-center text-lg-start pb-xl-2 mx-auto mx-lg-0 mb-5" style={{ maxWidth: '620px' }}> - это высокоэффективная трансформационная программа, направленная на достижение значимых результатов путем объединения усилий всех членов команды.</h2>
                  <ul className="list-unstyled fs-lg text-center text-lg-start pb-1 mx-auto mx-lg-0 mb-3" style={{ maxWidth: '620px' }}>
                    <p className="h4">Основные аспекты программы включают:</p>
                    <li className="mb-2">✔️ <strong>Объединение личных и организационных целей: </strong>Коуч помогает участникам осознать взаимосвязь между индивидуальными целями и общими задачами компании, создавая синергию внутри коллектива.</li>
                    <li className="mb-2">✔️ <strong>Разработка и написание формулировки миссии: </strong>Совместное определение миссии позволяет команде выработать общее видение и направление действий, что повышает мотивацию и согласованность работы.</li>
                    <li className="mb-2">✔️ <strong>Практика мозгового штурма: </strong>Групповые сессии мозговых штурмов способствуют креативному решению проблем и созданию новых идей, усиливая взаимодействие и сотрудничество среди участников.</li>
                    <li className="mb-2">✔️ <strong>Коучинг командного прорыва: </strong>Этот элемент направлен на преодоление барьеров и ограничений, мешающих эффективной работе команды, обеспечивая рост производительности и инноваций.</li>
                    <li className="mb-2">✔️ <strong>Разрешение конфликтов внутри команды: </strong>Коуч помогает членам команды научиться конструктивно решать конфликты, укрепляя доверие и взаимопонимание.</li>
                    <li className="mb-2">✔️ <strong>Упражнения на вовлеченность и развитие мотивации команды: </strong>Практические задания помогают повысить уровень заинтересованности сотрудников и создать благоприятную атмосферу для продуктивной работы.</li>
                    <br/>
                    {/* <p className="lead fs-xl text-center text-lg-start">Задача - получать удовольствие от развития бизнеса и собственного развития.</p> */}
                  {/* <div className="input-group mx-auto mx-lg-0" style={{maxWidth: '420px'}}><span class="input-group-text text-muted"><i class="ai-mail"></i></span>
                    <input className="form-control" type="email" placeholder="Enter your email" />
                    <button className="btn btn-primary" type="button">Book a call</button>
                  </div> */}
              
                  <p  className="lead fs-lg">Программа имеет продолжительность от трех часов, что делает её достаточно гибкой для адаптации под конкретные потребности организации.</p>
                  {/* <p className="mb-lg-3 fw-semibold">Рекомендуется 4-6 продвинутых сессий.</p> */}
                  <p  className="lead fs-lg">Стоимость: от 15 000 рублей (до 5 человек)</p>
                  <a className="nav-link fs-lg position-relative mb-2 " href="tel:+7(922)471-44-34"><strong>По всем интересующим вопросам можно обратиться: <br/> + 7(922)471-44-34, +7(992)300-65-46</strong></a>
                  <br/>   
                  </ul>
                </div>
              </div>
            <div className="container">
              <p className="m-1 position-relative text-center zindex-2 fw-bold h4"> Подробности о направлении и наличие мест уточняйте у администратора
              </p>
             <p className="fs-lg mb-2">Наши контакты:  
              <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle" href="https://vk.com/rubleva_coach"><i className="ai-vk"> </i> </a> 
              <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle" href="https://www.instagram.com/anyuta_rubleva"><i className="ai-instagram"> </i> </a> 
              <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle" href="https://t.me@AnnaRubleva_coach"><i className="ai-telegram"> </i> </a>
              <a className="nav-link fs-lg position-relative mb-2" href="mailto:developskillsnow@yandex.ru">Email: developskillsnow@yandex.ru</a>
             </p>
            </div>
            <div className="d-lg-none mt-3 p-1"> <p></p></div>
           </div>
          </section>
        </div>
      );
}
